export default {
  name: "contactSection",
  async created() {
    console.log(this);
    await this.$loadScript(
      "https://cdnjs.cloudflare.com/ajax/libs/gsap/1.18.0/TweenMax.min.js"
    );
    await this.$loadScript("./js/mapMarker.js");
  },
  methods: {
    onSubmitForm(ev) {
      ev.preventDefault();
      const form = ev.target;
      const data = new FormData(form);
      const xhr = new XMLHttpRequest();
      xhr.open(form.method, form.action);
      xhr.setRequestHeader("Accept", "application/json");
      xhr.onreadystatechange = () => {
        if (xhr.readyState !== XMLHttpRequest.DONE) return;
        if (xhr.status === 200) {
          form.reset();
          this.$toast.open({
            message: "Message bien envoyé",
            type: "success",
            // position: "top-right",
            // all of other options may go here
          });
        } else {
          this.$toast.open({
            message: "Erreur lors de l'envoie ",
            type: "error",
            // position: "top-right",
            // all of other options may go here
          });
        }
      };
      xhr.send(data);
    },
  },
};
